import { defineMessages } from 'react-intl';

export const snippetUsageMessages: {
	snippetUses: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	snippetUses: {
		id: 'snippets.common.usage.uses',
		defaultMessage: '{formattedCount} {count, plural, one {Use} other {Uses}}',
		description:
			'Shows the number of uses for a specific Block Template (singular "use" for 1, plural "uses" otherwise)',
	},
	privateLabel: {
		id: 'snippets.common.usage.private',
		defaultMessage: 'Private',
		description:
			'The text is shown as a label badge on a block template card to indicate that the template is private and not shared with other users in the site.',
	},
});
